export default "__VITE_ASSET___mMnCxc4__"